import { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import styles from "./NewAgentSearchPage.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { currentDateSingle, getDateByMonth } from "../../../utils/utils";
import {
  SvgCalender,
  SvgMan,
  SvgPlusCircle,
  SvgSearch,
} from "../../../utils/svgIcons";

function SinglePackageSearchForm({ packageData, topRadios }) {
  const [modifyPkg, setModiyPkg] = useState(false);
  const [mobileHead, setMobileHead] = useState(false);
  const [dataFromChild, setDataFromChild] = useState("");

  const toggleModify = () => {
    setModiyPkg(!modifyPkg);
  };
  const [guestDetails, setIsguestDetails] = useState(false);
  const dropdownGuestDetails = () => {
    setIsguestDetails(!guestDetails);
  };

  const [selectedLocation, setSelectedLocation] = useState(null);
  const [data, setData] = useState({ fromCity: "", toCity: "" });
  // console.log(data, "Location");

  const showErrorToast = (message) => {
    alert(message);
  };
  // functions for increase decrease
  const onChildDecrease = (e) => {
    e.preventDefault();
    const updatedChildren = Number(children) - 1;
    setChildren(updatedChildren);
    const updatedAges = childAge.slice(0, childAge.length - 1);
    setChildAge(updatedAges);
  };

  const onChildIncrease = (e) => {
    e.preventDefault();
    const updatedChildren = Number(children) + 1;
    setChildren(updatedChildren);
    setChildAge([...childAge, ""]);
  };

  const handleChildrenAgeChange = (index, event) => {
    const updatedAges = [...childAge];
    const ageValue = event.target.value.replace(/[^0-9]/g, "");

    if (ageValue > 12) {
      showErrorToast("Age should be less than or equal to 12");
      return;
    }

    updatedAges[index] = ageValue !== "" ? parseInt(ageValue, 10) : "";
    setChildAge(updatedAges);
  };

  const [bookingData, setBookingData] = useState({});
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    // Get the childAge parameters
    const childAges = [];
    let i = 1;
    while (params.has(`childAge[${i}]`)) {
      childAges.push(params.get(`childAge[${i}]`));
      i++;
    }

    const data = {
      location: params.get("location"),
      room: params.get("room"),
      guest: params.get("guest"),
      children: params.get("children"),
      radio: params.get("radio"),
      day: params.get("day"),
      month: params.get("month"),
      year: params.get("year"),
      childAge: childAges,
    };

    const date = `${data.year}-${String(data.month).padStart(2, "0")}-${String(
      data.day
    ).padStart(2, "0")}`;
    const checkOutDate = `${data.checkoutYear}-${String(
      data.checkoutMonth
    ).padStart(2, "0")}-${String(data.checkoutDay).padStart(2, "0")}`;

    setData({
      fromCity: params.get("location"),
      // toCity: params.get("location"),
    });

    setGuest(data.guest ? data.guest : 2);
    setChildren(data.children ? data.children : 0);
    setRooms(data.room);
    setChildAge(childAges);

    if (!data?.day) {
      setBookingData({ ...data, date: currentDateSingle });
      return;
    }

    setBookingData({ ...data, date });
    // postBookingData(data);
  }, [location.search]);

  const navigate = useNavigate();

  // STATES
  const [selectedRadio, setSelectedRadio] = useState("");

  //
  const [guest, setGuest] = useState(2);
  const [children, setChildren] = useState(0);
  const [rooms, setRooms] = useState(1);
  const [childAge, setChildAge] = useState([]);
  // console.log(children, "children");

  // Date alterations
  const [loader, setLoader] = useState(false);

  const dropdownRef = useRef(null);
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      // Click is outside the dropdown, so close it
      // setIsguestDetails(false);
    }
  };

  const getDataFromChild = (data, resultArray) => {
    setDataFromChild(data);
  };
  // console.log(dataFromChild, "getDataFromChild")

  const handleSubmitButtonClickHandler = async (e) => {
    // console.log("fghjgkhllj");

    setIsguestDetails(false);
    if (e) {
      e.preventDefault();
    }
    let hasChildAgeError = false;

    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      return;
    }

    // if (endDate <= startDate) {
    //   alert("Check out must be a date after check in");
    //   return;
    // }

    setLoader(true);
    setModiyPkg(false);

    try {
      await navigate(
        // location=Shimla&guest=2&children=0&&day=10&month=3&year=2025&radio=
        `/listing-holidays?hotelID=1&location=${dataFromChild}&guest=${guest}&children=${children}${childAgeParams}&day=${new Date(
          bookingData.date
        ).getDate()}&month=${
          new Date(bookingData.date).getMonth() + 1
        }&year=${new Date(
          bookingData.date
        ).getFullYear()}&radio=${selectedRadio}`,
        // `/searchresults?hotelID=&location=${property_city}&checkinDay=${checkin.day}&checkinMonth=${checkin.month}&checkinYear=${checkin.year}&checkoutDay=${checkout.day}&checkoutMonth=${checkout.month}&checkoutYear=${checkout.year}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkIn=${formated_start_date}&checkOut=${formated_end_date}&noOfNights=${noOfNights}#hotels`,
        undefined,
        { shallow: false }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
      setModiyPkg(false);
    } finally {
      setLoader(false);
    }
  };

  const handleSubmit = async (e) => {
    if (e) {
      e.preventDefault();
    }
    let hasChildAgeError = false;

    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      alert("Child age must be between 0 and 12");
      return;
    }

    try {
      await navigate(
        `/single-package-search/${packageData?.packageHandle}?packageId=${
          packageData?.packageId
        }&day=${new Date(bookingData.date).getDate()}&month=${
          new Date(bookingData.date).getMonth() + 1
        }&year=${new Date(
          bookingData.date
        ).getFullYear()}&guest=${guest}&children=${
          children ? children : 0
        }&${childAgeParams}`,

        // `/searchresults?hotelID=&location=${property_city}&checkinDay=${checkin.day}&checkinMonth=${checkin.month}&checkinYear=${checkin.year}&checkoutDay=${checkout.day}&checkoutMonth=${checkout.month}&checkoutYear=${checkout.year}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkIn=${formated_start_date}&checkOut=${formated_end_date}&noOfNights=${noOfNights}#hotels`,
        undefined,
        { shallow: false }
      );
      setModiyPkg(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  const [filteredData, setFilteredData] = useState({
    location: "",
    rooms: "",
    adults: "",
    children: "",
    radio: "",
    childAge: [],
  });

  useEffect(() => {
    setFilteredData({
      location: data.fromCity,
      guest: guest,
      radio: selectedRadio,
    });
  }, [data.fromCity, rooms, guest, children, selectedRadio, childAge]);

  // console.log(filteredData);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const updateDimensions = () => {
    // console.log("window.innerWidth", window.innerWidth);

    if (width > 640) {
      setMobileHead(false);
    } else {
      setMobileHead(true);
    }
  };

  useEffect(() => {
    // Call the function on initial render
    // updateDimensions();

    // Add event listener for window resize
    window.addEventListener("resize", updateDimensions);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("resize", updateDimensions);
  }, [width]);

  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const popupsRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (popupsRef.current && !popupsRef.current.contains(event.target)) {
        setIsguestDetails(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);
  const [showGuestDetailsPopup, setShowGuestDetailsPopup] = useState(false);
  const availableAges = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

  // Function to add a child's age
  const handleAddChildAge = (age) => {
    setChildAge((prevAges) => {
      const newAges = [...prevAges, age];
      setChildren(newAges.length);
      return newAges;
    });
    setShowGuestDetailsPopup(false);
  };

  // Function to remove a child's age
  const handleRemoveChild = (indexToRemove) => {
    setChildAge((prevAges) => {
      const newAges = prevAges.filter((_, index) => index !== indexToRemove);
      setChildren(newAges.length);
      return newAges;
    });
  };

  return (
    <section className={styles.EditSearchParentWrapper}>
      <div className={styles.singleSearch} id="singleSearch">
        <form
          action=""
          className={styles.EditSearchFormWrapper}
          id="main-form"
          onSubmit={handleSubmit}
        >
          {width <= 640 ? (
            <>
              {/* <div className={styles.EditSearchParentWrapperMobile}>
                <div className="flex_align_center">
                  <span onClick={() => window.history.back()}>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.292893 7.29289C-0.0976311 7.68342 -0.0976311 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292893 7.29289ZM1 9H16V7H1V9Z"
                        fill="#333333"
                      />
                    </svg>
                  </span>
                  <div className="SingleSearch-resp_content">
                    <h4 style={{ fontSize: "16px", lineHeight: "20px" }}>
                      {data?.fromCity ? (
                        capitalizeFirstLetter(data.fromCity)
                      ) : (
                        <p>Enter a destination</p>
                      )}
                    </h4>
                    <div style={{ fontSize: "14px", lineHeight: "20px" }}>
                      <span>{guest} Guests </span>
                      <span id="child_count"> {children} </span>
                      <span> Children </span>
                    </div>
                  </div>
                </div>
                <div onClick={toggleModify}>
                  {modifyPkg ? (
                    <span style={{ marginRight: "10px" }}>X</span>
                  ) : (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_2797_7470"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="20"
                        height="20"
                      >
                        <rect width="20" height="20" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_2797_7470)">
                        <path
                          d="M4.16667 15.8333H5.35417L13.5 7.6875L12.3125 6.5L4.16667 14.6458V15.8333ZM2.5 17.5V13.9583L13.5 2.97917C13.6667 2.82639 13.8507 2.70833 14.0521 2.625C14.2535 2.54167 14.4653 2.5 14.6875 2.5C14.9097 2.5 15.125 2.54167 15.3333 2.625C15.5417 2.70833 15.7222 2.83333 15.875 3L17.0208 4.16667C17.1875 4.31944 17.309 4.5 17.3854 4.70833C17.4618 4.91667 17.5 5.125 17.5 5.33333C17.5 5.55556 17.4618 5.76736 17.3854 5.96875C17.309 6.17014 17.1875 6.35417 17.0208 6.52083L6.04167 17.5H2.5ZM12.8958 7.10417L12.3125 6.5L13.5 7.6875L12.8958 7.10417Z"
                          fill="#333333"
                        />
                      </g>
                    </svg>
                  )}
                </div>
              </div> */}

              <div className={styles.mobile_new_wrapper_container}>
                <div
                  onClick={toggleModify}
                  className={styles.mobile_new_wrapper}
                >
                  <div className={styles.mobile_new_left_div}>
                    <div>
                      <SvgSearch />
                    </div>
                    <div className={styles.mobile_new_left_div_location}>
                      {/* {data.fromCity || data.fromCity != null  &&
                        capitalizeFirstLetter(data.fromCity) + ", "} */}
                      <span>{getDateByMonth(bookingData?.date)}</span>
                    </div>
                  </div>

                  <div className={styles.mobile_new_right_div}>
                    <div className={styles.mobile_new_right_div_svg}>
                      <SvgMan />
                    </div>
                    <div className={styles.mobile_new_right_div_guest}>
                      {" "}
                      {guest}
                    </div>
                  </div>
                </div>

                {modifyPkg && (
                  <div className={styles.lower_form}>
                    {/* <div>
                      <label htmlFor="">City/Destination</label>
                      <PackagesStateInputNewUi onDataChange={getDataFromChild} />
                    </div> */}
                    <div className={styles.mobile_travel_date_edit}>
                      <label className="search_label">Travel Date</label>
                      {/* <Flatpickr
                        i
                        className="m_0 testform_input pac-target-input"
                        color="#ffffff"
                        value={bookingData?.date}
                        onChange={([date]) =>
                          setBookingData((prev) => ({ ...prev, date }))
                        }
                        min={new Date()}
                      /> */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "baseline",
                        }}
                      >
                        <div
                          className={`new_date_picker_react_js_custom_styling`}
                        >
                          <DatePicker
                            selected={bookingData?.date}
                            onChange={(date) =>
                              setBookingData((prev) => ({ ...prev, date }))
                            }
                            portalId="root-portal NewUIReactDatePicker"
                            popperPlacement="bottom-start"
                            minDate={new Date()}
                            dateFormat="dd MMM, yyyy"
                            placeholderText={
                              bookingData?.date
                                ? format(bookingData?.date, "dd MMM, yyyy")
                                : "Travel Date"
                            }
                          />
                        </div>
                        <div>
                          <SvgCalender />
                        </div>
                      </div>
                    </div>
                    <div className="search_form_div p_0 icon_button_only">
                      <label
                        onClick={dropdownGuestDetails}
                        className="search_label"
                      >
                        Guests{" "}
                        <svg
                          width="9"
                          height="5"
                          viewBox="0 0 9 5"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.25 0.75L4.75 4.25L1.25 0.75"
                            stroke="#BB735D"
                          />
                        </svg>
                      </label>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "baseline",
                        }}
                        onClick={dropdownGuestDetails}
                        ref={dropdownRef}
                      >
                        <div>
                          <p
                            id="guest_input"
                            style={{ position: "relative" }}
                            className="SingleSearch-Guests dropdown-toggle search_form_input "
                          >
                            <div>
                              <div className="optionCounter"></div>
                              <span id="adult_count">{guest}</span>
                              <span> Guests</span>
                              <span id="child_count"> {children}</span>
                              <span> Children</span>
                            </div>
                            {guestDetails && (
                              <div
                                style={{ left: "0px" }}
                                className="guest_details_dropdown"
                                id="guestDetailsPopup"
                                ref={popupsRef}
                              >
                                <div className="agent">
                                  <span>Guests</span>
                                  <div className="flex align_items_center">
                                    <button
                                      type="button"
                                      disabled={guest <= 1}
                                      className="optionCounterButton optionCounterButtonWithBorder"
                                      onClick={() =>
                                        setGuest(Number(guest) - 1)
                                      }
                                    >
                                      <span
                                        className="onclick_btn"
                                        id="adult_minus"
                                      >
                                        -
                                      </span>
                                    </button>

                                    <input
                                      className="optionCounterNumber"
                                      value={guest}
                                      min={1}
                                      type="number"
                                      // onChange={(e) => setGuest(e.target.value)}
                                      onChange={(e) => {
                                        let value = Number(e.target.value);
                                        if (isNaN(value)) return;
                                        setGuest(
                                          Math.min(11, Math.max(2, value))
                                        );
                                      }}
                                    />

                                    <button
                                      type="button"
                                      // disabled={rooms <= 1}
                                      className="optionCounterButton optionCounterButtonWithBorder"
                                      onClick={() =>
                                        setGuest(Number(guest) + 1)
                                      }
                                    >
                                      <span
                                        className="onclick_btn"
                                        id="adult_plus"
                                      >
                                        +
                                      </span>
                                    </button>
                                  </div>
                                </div>
                                <div>
                                  {childAge.map((age, index) => (
                                    <div
                                      className="agent flex items-center gap-2"
                                      key={index}
                                    >
                                      <span>
                                        Child{" "}
                                        <small style={{ fontSize: "12px" }}>
                                          {" "}
                                          ({age} Yrs){" "}
                                        </small>
                                      </span>
                                      <div
                                        className="remove_svg"
                                        onClick={() => handleRemoveChild(index)}
                                      >
                                        <svg
                                          width="18"
                                          height="18"
                                          viewBox="0 0 18 18"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <mask
                                            id="mask0_6577_13294"
                                            style={{ maskType: "alpha" }}
                                            maskUnits="userSpaceOnUse"
                                            x="0"
                                            y="0"
                                            width="18"
                                            height="18"
                                          >
                                            <rect width="18" height="18" />
                                          </mask>
                                          <g mask="url(#mask0_6577_13294)">
                                            <path d="M6.3 12.4903L9 9.79031L11.7 12.4903L12.4903 11.7L9.79031 9L12.4903 6.3L11.7 5.50969L9 8.20969L6.3 5.50969L5.50969 6.3L8.20969 9L5.50969 11.7L6.3 12.4903ZM9.00131 16.125C8.01581 16.125 7.0895 15.938 6.22237 15.564C5.35525 15.19 4.601 14.6824 3.95962 14.0413C3.31825 13.4002 2.81044 12.6463 2.43619 11.7795C2.06206 10.9128 1.875 9.98669 1.875 9.00131C1.875 8.01581 2.062 7.0895 2.436 6.22237C2.81 5.35525 3.31756 4.601 3.95869 3.95962C4.59981 3.31825 5.35375 2.81044 6.2205 2.43619C7.08725 2.06206 8.01331 1.875 8.99869 1.875C9.98419 1.875 10.9105 2.062 11.7776 2.436C12.6448 2.81 13.399 3.31756 14.0404 3.95869C14.6818 4.59981 15.1896 5.35375 15.5638 6.2205C15.9379 7.08725 16.125 8.01331 16.125 8.99869C16.125 9.98419 15.938 10.9105 15.564 11.7776C15.19 12.6448 14.6824 13.399 14.0413 14.0404C13.4002 14.6818 12.6463 15.1896 11.7795 15.5638C10.9128 15.9379 9.98669 16.125 9.00131 16.125Z" />
                                          </g>
                                        </svg>
                                      </div>
                                    </div>
                                  ))}

                                  {/* Add a child button */}
                                  <div className="relative">
                                    <div
                                      className="flex align_items_center justify_content_between border"
                                      style={{
                                        padding: "10px ",
                                        marginBottom: "10px",
                                        fontWeight: "400",
                                      }}
                                      onClick={() =>
                                        setShowGuestDetailsPopup(
                                          !showGuestDetailsPopup
                                        )
                                      }
                                    >
                                      Add a Child
                                      <div>
                                        <svg
                                          width="12"
                                          height="6"
                                          viewBox="0 0 12 6"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M5.99982 4.64202L10.3939 0.247911C10.5098 0.132021 10.6463 0.0755358 10.8033 0.0784526C10.9604 0.0814662 11.0969 0.140917 11.2128 0.256806C11.3287 0.372792 11.3866 0.509293 11.3866 0.666307C11.3866 0.82332 11.3287 0.95982 11.2128 1.07581L6.74693 5.55056C6.64144 5.65604 6.52327 5.73421 6.39241 5.78506C6.26155 5.8359 6.13069 5.86133 5.99983 5.86133C5.86896 5.86133 5.7381 5.8359 5.60724 5.78506C5.47638 5.73421 5.35821 5.65604 5.25272 5.55056L0.777825 1.07581C0.661936 0.959821 0.605499 0.821814 0.608513 0.661786C0.611527 0.501759 0.670978 0.3638 0.786867 0.247911C0.902756 0.132022 1.03926 0.0740781 1.19637 0.0740781C1.35338 0.0740781 1.48983 0.132022 1.60572 0.247911L5.99982 4.64202Z"
                                            fill="#1C1B1F"
                                          />
                                        </svg>
                                      </div>
                                    </div>

                                    {/* Child age selection popup */}
                                    {showGuestDetailsPopup && (
                                      <div className="new_guest_details_popup mt-2 bg-white p-4 shadow-lg rounded-lg">
                                        {availableAges.map((age, i) => (
                                          <div
                                            className="new-age-option"
                                            key={i}
                                            onClick={() =>
                                              handleAddChildAge(age)
                                            }
                                            style={{ fontWeight: "400" }}
                                          >
                                            {age} Years
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                          </p>
                        </div>
                        <div>
                          <SvgPlusCircle />
                        </div>
                      </div>
                    </div>
                    <button
                      style={{ marginTop: "10px" }}
                      type="submit"
                      className={styles.submitButton}
                    >
                      Modify
                    </button>
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className={styles.EditSearchFormParent}>
              <div className={styles.EditSearchFormChild}>
                {/* <div className={styles.EditSearchFormChildFirstDiv}>
                  <PackagesStateInputNewUi onDataChange={getDataFromChild} />
                </div> */}

                <div
                  className={`${styles.EditSearchFormChildSecondDiv} new_date_picker_react_js_custom_styling`}
                >
                  {/* <Flatpickr
                    i
                    className="m_0 testform_input pac-target-input"
                    color="#ffffff"
                    value={bookingData?.date}
                    onChange={([date]) =>
                      setBookingData((prev) => ({ ...prev, date }))
                    }
                    min={new Date()}
                  /> */}

                  <DatePicker
                    showIcon
                    selected={bookingData?.date}
                    onChange={(date) =>
                      setBookingData((prev) => ({ ...prev, date }))
                    }
                    portalId="root-portal NewUIReactDatePicker"
                    popperPlacement="bottom-start"
                    minDate={new Date()}
                    dateFormat="dd MMM, yyyy"
                    placeholderText={
                      bookingData?.date
                        ? format(bookingData?.date, "dd MMM, yyyy")
                        : "Travel Date"
                    }
                  />
                </div>
                <div className={styles.EditSearchFormChildThirdDiv}>
                  <p
                    id="guest_input"
                    style={{ position: "relative" }}
                    className="SingleSearch-Guests dropdown-toggle search_form_input testform_input"
                  >
                    <div onClick={dropdownGuestDetails} ref={dropdownRef}>
                      <div className="optionCounter"></div>
                      <span id="adult_count">{guest}</span>
                      <span> Guests</span>
                      <span id="child_count"> {children} </span>
                      <span> Children</span>
                    </div>
                    {guestDetails && (
                      <div
                        style={{ left: "0px" }}
                        className="guest_details_dropdown"
                        id="guestDetailsPopup"
                        ref={popupsRef}
                      >
                        <div className="agent">
                          <span>Guests</span>
                          <div className="flex align_items_center">
                            <button
                              type="button"
                              disabled={guest <= 2}
                              className="optionCounterButton optionCounterButtonWithBorder"
                              onClick={() => {
                                if (guest <= 2) return;
                                setGuest(Number(guest) - 1);
                              }}
                            >
                              <span className="onclick_btn" id="adult_minus">
                                -
                              </span>
                            </button>

                            <input
                              className="optionCounterNumber"
                              value={guest}
                              min={1}
                              type="number"
                              // onChange={(e) => setGuest(e.target.value)}
                              onChange={(e) => {
                                let value = Number(e.target.value);
                                if (isNaN(value)) return;
                                setGuest(Math.min(11, Math.max(2, value)));
                              }}
                            />

                            <button
                              type="button"
                              disabled={guest >= 11}
                              className="optionCounterButton optionCounterButtonWithBorder"
                              onClick={() => {
                                if (guest >= 11) return;
                                setGuest(Number(guest) + 1);
                              }}
                            >
                              <span className="onclick_btn" id="adult_plus">
                                +
                              </span>
                            </button>
                          </div>
                        </div>
                        <div>
                          {childAge.map((age, index) => (
                            <div
                              className="agent flex items-center gap-2"
                              key={index}
                            >
                              <span>
                                Child{" "}
                                <small style={{ fontSize: "12px" }}>
                                  {" "}
                                  ({age} Yrs){" "}
                                </small>
                              </span>
                              <div
                                className="remove_svg"
                                onClick={() => handleRemoveChild(index)}
                              >
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <mask
                                    id="mask0_6577_13294"
                                    style={{ maskType: "alpha" }}
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="18"
                                    height="18"
                                  >
                                    <rect width="18" height="18" />
                                  </mask>
                                  <g mask="url(#mask0_6577_13294)">
                                    <path d="M6.3 12.4903L9 9.79031L11.7 12.4903L12.4903 11.7L9.79031 9L12.4903 6.3L11.7 5.50969L9 8.20969L6.3 5.50969L5.50969 6.3L8.20969 9L5.50969 11.7L6.3 12.4903ZM9.00131 16.125C8.01581 16.125 7.0895 15.938 6.22237 15.564C5.35525 15.19 4.601 14.6824 3.95962 14.0413C3.31825 13.4002 2.81044 12.6463 2.43619 11.7795C2.06206 10.9128 1.875 9.98669 1.875 9.00131C1.875 8.01581 2.062 7.0895 2.436 6.22237C2.81 5.35525 3.31756 4.601 3.95869 3.95962C4.59981 3.31825 5.35375 2.81044 6.2205 2.43619C7.08725 2.06206 8.01331 1.875 8.99869 1.875C9.98419 1.875 10.9105 2.062 11.7776 2.436C12.6448 2.81 13.399 3.31756 14.0404 3.95869C14.6818 4.59981 15.1896 5.35375 15.5638 6.2205C15.9379 7.08725 16.125 8.01331 16.125 8.99869C16.125 9.98419 15.938 10.9105 15.564 11.7776C15.19 12.6448 14.6824 13.399 14.0413 14.0404C13.4002 14.6818 12.6463 15.1896 11.7795 15.5638C10.9128 15.9379 9.98669 16.125 9.00131 16.125Z" />
                                  </g>
                                </svg>
                              </div>
                            </div>
                          ))}

                          {/* Add a child button */}
                          <div className="relative">
                            <div
                              className="flex align_items_center justify_content_between border"
                              style={{
                                padding: "10px ",
                                marginBottom: "10px",
                                fontWeight: "400",
                              }}
                              onClick={() =>
                                setShowGuestDetailsPopup(!showGuestDetailsPopup)
                              }
                            >
                              Add a Child
                              <div>
                                <svg
                                  width="12"
                                  height="6"
                                  viewBox="0 0 12 6"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M5.99982 4.64202L10.3939 0.247911C10.5098 0.132021 10.6463 0.0755358 10.8033 0.0784526C10.9604 0.0814662 11.0969 0.140917 11.2128 0.256806C11.3287 0.372792 11.3866 0.509293 11.3866 0.666307C11.3866 0.82332 11.3287 0.95982 11.2128 1.07581L6.74693 5.55056C6.64144 5.65604 6.52327 5.73421 6.39241 5.78506C6.26155 5.8359 6.13069 5.86133 5.99983 5.86133C5.86896 5.86133 5.7381 5.8359 5.60724 5.78506C5.47638 5.73421 5.35821 5.65604 5.25272 5.55056L0.777825 1.07581C0.661936 0.959821 0.605499 0.821814 0.608513 0.661786C0.611527 0.501759 0.670978 0.3638 0.786867 0.247911C0.902756 0.132022 1.03926 0.0740781 1.19637 0.0740781C1.35338 0.0740781 1.48983 0.132022 1.60572 0.247911L5.99982 4.64202Z"
                                    fill="#1C1B1F"
                                  />
                                </svg>
                              </div>
                            </div>

                            {/* Child age selection popup */}
                            {showGuestDetailsPopup && (
                              <div className="new_guest_details_popup mt-2 bg-white p-4 shadow-lg rounded-lg">
                                {availableAges.map((age, i) => (
                                  <div
                                    className="new-age-option"
                                    key={i}
                                    onClick={() => handleAddChildAge(age)}
                                    style={{ fontWeight: "400" }}
                                  >
                                    {age} Years
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </p>
                </div>
              </div>

              <button type="submit" className={styles.submitButton}>
                Modify
              </button>
            </div>
          )}
        </form>

        <input type="hidden" name="hotelId" value="{{ $hotelId }}" />
      </div>
    </section>
  );
}

export default SinglePackageSearchForm;
